import { createApp } from 'vue'
import router from './router.js'
import store from './store'

const app = createApp({})

app.use(router)
app.use(store)

app.mount('#app')